export default __webpack_public_path__ + "static/media/FT1.cf2acdfc.png";